import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError, firstValueFrom, of, switchMap, tap } from 'rxjs';
import { resetPasswordApi } from 'src/app/services/constants/api.constants';
import { ToastService, AuthService, HttpBaseService } from '@evento-ng/libs';
import { Toast } from 'src/app/services/enums/toast';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  isValidated!: boolean;
  changePasswordForm!: FormGroup;
  constructor(
    private spinner: NgxSpinnerService,
    private toast: ToastService,
    private dataService: HttpBaseService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private fb: FormBuilder,
    private modalService: ModalService,
    private translate: TranslateService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {}

  ngOnInit(): void {
    this.validate();
  }

  validate(): void {
    this.spinner.show();
    const id = this.route.snapshot.paramMap.get('id');
    firstValueFrom(
      this.dataService
        .post(
          `${resetPasswordApi}/${id}/validate`,
          {},
          { headers: { 'Accept-Language': this.translate.currentLang } }
        )
        .pipe(
          tap((_) => {
            this.spinner.hide();
            this.initForm();
            this.isValidated = true;
          }),
          catchError((error: any) => {
            console.error('Validation error:', error);
            this.spinner.hide();
            this.isValidated = false;
            return of(null);
          })
        )
    );
  }

  private initForm(): void {
    this.changePasswordForm = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
      },
      {
        validators: [this.MustMatch('password', 'confirmPassword')],
      }
    );
  }

  MustMatch(controlName: string, matchingControlName: string): any {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors['mustMatch']) {
        return;
      }

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  changePassword(): void {
    this.spinner.show();
    const id = this.route.snapshot.paramMap.get('id');
    this.recaptchaV3Service
      .execute('changePasswordApi')
      .pipe(
        switchMap((token: any) => {
          return this.dataService.post(
            `${resetPasswordApi}/${id}/update`,
            {
              ...this.changePasswordForm.value,
              recaptcha: token,
            },
            { headers: { 'Accept-Language': this.translate.currentLang } }
          );
        }),
        tap((_: any) => {
          this.spinner.hide();
          this.navigateToHomeAndOpenLoginModal();
          this.authService.logout().subscribe({
            next: () => {
              console.log('Logout successful');
              this.router.navigate(['/']);
            },
            error: (err: any) => {
              console.error('Logout error:', err);
            },
          });
          this.toast.show(
            'Success',
            this.translate.instant('Password has been changed'),
            {
              classname: Toast.success,
            }
          );
        })
      )
      .subscribe();
  }

  navigateToHomeAndOpenLoginModal() {
    this.router.navigate(['/home']).then(() => {
      this.modalService.openModal('resetLogin');
    });
  }
}
